import { Modal } from "@next-platform/client-common-spicy-ui";
import React from "react";

import { Text } from "../../customComponents";
import { WarningModalProps } from "./types";

export default function WarningModal(props: WarningModalProps) {
  const { isVisible, onClose, heading, message } = props;
  return (
    <Modal title={heading} open={isVisible} onOpenChange={onClose}>
      {message && (
        <Text variant={"md"} type={"normal"}>
          {message}
        </Text>
      )}
    </Modal>
  );
}
